import { Component } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-section-loader',
  standalone: true,
  styleUrls: ['./section-loader.component.scss'],
  imports: [MatProgressSpinner],
  template: `
    <div class="d-flex flex-column align-items-center justify-content-center min-h-100">
      <mat-spinner></mat-spinner>
      <div class="mt-8">
        <p class="text-gray-600">Memuat Data</p>
      </div>
    </div>
  `,
})
export class SectionLoaderComponent {}
